import useMediaQuery from '@mui/material/useMediaQuery';
import SideBarContainer from './SideBarContainer';
import MobileNav from './MobileNav';
import { FIRST_MEDIA_QUERY } from '../shared/configs/MEDIA_QUERY_VALUES';


function NavBarContainer(props) {

    const matches = useMediaQuery(FIRST_MEDIA_QUERY);

    if (!matches) return  <MobileNav />;
    return <SideBarContainer />;

}

export default NavBarContainer;
